module.exports = new __parcel__URL__("approvals-preview-dark.6d3cc8df.svg").toString();